import { db } from '../config/firebase';
import { collection, addDoc } from 'firebase/firestore';

export async function writeAuditLog({ action, entityType, entityId, performedBy, performedByName, details = {} }) {
  await addDoc(collection(db, 'audit_log'), {
    action,
    entity_type: entityType,
    entity_id: entityId,
    performed_by: performedBy,
    performed_by_name: performedByName || null,
    performed_at: new Date().toISOString(),
    details,
  });
}

export async function writeDealAuditLog({ dealId, action, performedBy, performedByName, details = {}, stageAtTime = null }) {
  await addDoc(collection(db, 'deals', dealId, 'audit_log'), {
    deal_id: dealId,
    action,
    performed_by: performedBy,
    performed_by_name: performedByName || null,
    performed_at: new Date().toISOString(),
    details,
    stage_at_time: stageAtTime,
  });
}
